<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="miniVariant"
      :clipped="clipped"
      fixed
      app
    >
      <v-list>
        <v-list-tile
          v-for="(item, i) in items"
          :key="i"
          :to="item.to"
          router
          exact
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title" />
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="clipped"
      :color="toolbarColor"
      dark
      fixed
      app
    >
      <v-toolbar-side-icon @click="drawer = !drawer" />
      <!-- <v-btn
        icon
        @click.stop="miniVariant = !miniVariant"
      >Cerrar sesión</v-btn> -->
      <!-- <v-btn
        icon
        @click.stop="miniVariant = !miniVariant"
      >
        <v-icon>{{ `chevron_${miniVariant ? 'right' : 'left'}` }}</v-icon>
      </v-btn> -->
      <!-- <v-btn
        icon
        @click.stop="clipped = !clipped"
      >
        <v-icon>web</v-icon>
      </v-btn> -->
      <!-- <v-btn
        icon
        @click.stop="fixed = !fixed"
      >
        <v-icon>remove</v-icon>
      </v-btn> -->
      <v-toolbar-title v-text="title" />
      <v-spacer />
      <v-btn
        icon
        @click.stop="cerrarSesion()"
      >
        <v-icon>power_settings_new</v-icon>
      </v-btn>
      <v-btn
        icon
        @click.stop="rightDrawer = !rightDrawer"
      >
        <v-icon>apps</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-navigation-drawer
      v-model="rightDrawer"
      :right="right"
      temporary
      fixed
    >
      <v-list>
        <v-list-tile href="#">
          <v-list-tile-action>
            <v-icon light>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Configuración</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-footer
      :fixed="fixed"
      app
    >
      <span>&copy;SG2 - {{new Date().getFullYear()}}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters} from 'vuex'
import axios from 'axios'

export default {
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken"
    ])
  },
  data() {
    return {
      toolbarColor: 'indigo',
      clipped: true,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'home',
          title: 'Inicio',
          to: '/inicio'
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Recursos Humanos'
    }
  },
  created(){
    if( sessionStorage.getItem("token") )
      this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
    if( localStorage.getItem("token") )
      this.$store.dispatch("setSessionToken", localStorage.getItem("token"));

    if( !this.sessionToken )
        this.$router.push('/login');

    axios.get(this.httpURL+'/login',{headers:{token:this.sessionToken}})
      .then(res => {
          this.$store.dispatch("setUserName", res.data.nombre);
          this.$store.dispatch("setPermisos", res.data.permisos);
          this.$store.dispatch("setRole", res.data.role);
          this.$store.dispatch("setUserId", res.data.id);
          this.items = this.items.concat(res.data.menu);
      })
      .catch(error => {
          // console.log('Error: '+error);
          if(error.response)
            this.$router.push('/login');
      });
  },
  methods:{
    cerrarSesion(){
      localStorage.removeItem('token');
			sessionStorage.removeItem('token');
			this.$store.dispatch("setSessionToken", null);
			this.$router.push('/login');  
    }
  }
}
</script>
